import React from 'react'
import './OrderIndex.sass'
import { ScrollSyncPane } from 'react-scroll-sync'

const OrderIndex = () => {
  return (
    <div className='order_index_header'>
      <div className='order_index_header_wrapper'>
        <div className='column-one created_at_header header_label'>
          <div>
            Pick Up Date
          </div>
        </div>
        <ScrollSyncPane>
          <div className='scroll'>
            <div className='name_header header_label'>
              <div>
                Name
              </div>
            </div>
            <div className='street_address_header header_label'>
              <div>
                Street Address
              </div>
            </div>
            <div className='email_header header_label'>
              <div>
                Email
              </div>
            </div>
            <div className='phone_number_header header_label'>
              <div>
                Phone
              </div>
            </div>
          </div>
        </ScrollSyncPane>
      </div>
    </div>
  )
}

export default OrderIndex



// WEBPACK FOOTER //
// ./src/Reservations/IndexHeader.jsx